import { Injectable, inject } from '@angular/core';
import { UpdateUserSignatureProfileRequest } from '@interfaces/email-signatures/requests/update-user-signature-profile.request';
import { UserSignatureProfileResponse } from '@interfaces/email-signatures/responses/user-signature-profile.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/**
 * Perfil de assinatura de e-mail de um usuário (card 3456): cargo, área e selos de certificação que
 * saem no RFQ ao banco e no Relatório de Posição. Backend `api/v1/users/{userId}/signature-profile`,
 * as duas rotas com a permissão `USER_UPDATE`.
 */
@Injectable({ providedIn: 'root' })
export class UserSignatureProfileHttpService {
  private readonly api = inject(VaultApiService);

  /** Perfil atual e os selos ativos do catálogo, para montar a escolha. */
  getProfile(userId: string): Observable<UserSignatureProfileResponse | null> {
    return this.api.get<UserSignatureProfileResponse>(`users/${userId}/signature-profile`);
  }

  /** Grava cargo, área e selos (na ordem da fileira). */
  updateProfile(
    userId: string,
    payload: UpdateUserSignatureProfileRequest
  ): Observable<UserSignatureProfileResponse | null> {
    return this.api.put<UserSignatureProfileResponse>(`users/${userId}/signature-profile`, payload);
  }
}
